import type { Libraries } from '@react-google-maps/api';

/**
 * Shared Google Maps JS loader options. All `useJsApiLoader` calls
 * across the app MUST use this exact same `libraries` array, otherwise
 * the loader caches the first set and refuses to load a different one,
 * leaving subsequent maps stuck in `isLoaded=false`.
 */
export const GOOGLE_LIBRARIES: Libraries = ['geometry', 'drawing', 'places'];
